import {
  WSActions,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

type ModalConfirmExitProps = {
  onClose(confirmed: boolean): void;
};

export const ModalConfirmExit: React.FC<ModalConfirmExitProps> = ({
  onClose
}) => {
  return (
    <WSList gap="L">
      <WSText.ParagraphSm color="gray500">
        Are you sure you want to exit version creation?
      </WSText.ParagraphSm>
      <WSInfoBox>
        Your progress will not be saved. You will need to start the version
        creation process again.
      </WSInfoBox>
      <WSActions
        alignment="fill"
        buttons={[
          {
            kind: "Secondary",
            label: "Go back",
            onClick: () => onClose(false),
            type: "button"
          },
          {
            destructive: true,
            kind: "Primary",
            label: "Exit version creation",
            onClick: () => onClose(true),
            type: "button"
          }
        ]}
        sortButtons={false}
      />
    </WSList>
  );
};
